// import {itemDefault, detailDefault} from '../util/defaults'

export default {
  data: function () {
    return {
      selectedMemberPreferencesId: null
    }
  }
}
